import GatheringAccessEnum from "src/api/graphql/__generated__/enums/GatheringAccessEnum";
import GatheringPrivacy from "src/api/graphql/__generated__/enums/GatheringPrivacy";
import NotificationDot from "src/components/NotificationDot";
import PillButton from "src/components/PillButton";
import { useGatheringStore } from "src/contexts/GatheringContext";
import abbreviateBigNumber from "src/helpers/abbreviateBigNumber";
import IconMessages from "src/icons/IconMessages";
import { useModal } from "src/modals";
import GatheringModal from "src/modals/configs/GatheringModal";
import usePhotoDetailStore from "../../stores/usePhotoDetailStore";
import { PhotoItem } from "../../types";

const PhotoDetailCommentButton = ({ photo }: { photo: PhotoItem }) => {
	const { presentModal } = useModal<GatheringModal>();
	const gatheringId = useGatheringStore((state) => state.gatheringId);
	const access = useGatheringStore((state) => state.access);
	const privacy = useGatheringStore((state) => state.privacy);
	const asyncSettledPhoto = usePhotoDetailStore((state) => state.asyncSettledPhoto);

	if (!privacy?.includes(GatheringPrivacy.EnableComments)) return null;
	return (
		<NotificationDot enabled={asyncSettledPhoto?.hasNewComments ?? false}>
			<PillButton
				testID="PhotoDetailCommentButton"
				blur
				Icon={IconMessages}
				sizeVariant="lg"
				onPress={async () => {
					presentModal("PhotoCommentsThread", {
						props: {
							gatheringId,
							photoId: photo.photoId,
							isAdmin: access === GatheringAccessEnum.Admin,
						},
					});
				}}
			>
				{photo.numComments != null && photo.numComments > 0
					? abbreviateBigNumber(photo.numComments)
					: undefined}
			</PillButton>
		</NotificationDot>
	);
};
export default PhotoDetailCommentButton;
